import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  formStatusShowingExplainText,
  formStatusReset,
} from '../../actions/formActions';
import PropTypes from 'prop-types';

// Module-level counter for unique explain IDs
let explainIdCounter = 0;

class Explain extends Component {
  constructor() {
    super();
    this.explainContentRef = React.createRef();
    this.triggerRef = React.createRef();
    this.handleShow = this.handleShow.bind(this);
    this.handleKeyboardEvents = this.handleKeyboardEvents.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.state = { openedViaKeyboard: false };
    // Generate unique ID once for this explain instance
    explainIdCounter += 1;
    this.explainId = `explain-${explainIdCounter}`;
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyboardEvents);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyboardEvents);
  }

  handleKeyboardEvents(event) {
    if (event?.key === 'Escape' && this.props.show) {
      event.preventDefault();
      this.props.dispatch(formStatusReset());
      this.setState({ openedViaKeyboard: false });
      // Focus remains on trigger per WCAG guidelines
    }
  }

  handleKeyDown(event) {
    if (event?.key === 'Enter' || event?.key === ' ') {
      event.preventDefault();
      this.handleShow(event);
    }
  }

  handleShow(event) {
    const isKeyboardEvent = event && event.type === 'keydown';

    if (!this.props.show) {
      this.setState({ openedViaKeyboard: isKeyboardEvent });
      this.props.dispatch(formStatusShowingExplainText());

      // Focus remains on trigger per WCAG guidelines
      // Content is announced via aria-describedby and live regions
    } else {
      // Close explanation
      this.props.dispatch(formStatusReset());
      this.setState({ openedViaKeyboard: false });
      // Focus remains on trigger per WCAG guidelines
    }
  }

  render() {
    let {
      content,
      show,
      classExt,
      buttonText = 'OK',
      attributeDescriptiveName,
    } = this.props;
    const explainTextPositions = ['topRight', 'headline'];
    buttonText = buttonText === '' ? 'OK' : buttonText;
    if (content?.length === 0) {
      return null;
    }

    return (
      <div
        className={
          content && content.length > 0 ? `ltFormExplain ${classExt}` : null
        }
        style={window.LT5theme ? { display: 'inline' } : {}}
      >
        {window.ltExplainTextPosition &&
        explainTextPositions.includes(window.ltExplainTextPosition) &&
        content &&
        content.length > 0 ? (
          <a
            ref={this.triggerRef}
            role="button"
            tabIndex={0}
            onClick={this.handleShow}
            onKeyDown={this.handleKeyDown}
            aria-describedby={show ? this.explainId : undefined}
            aria-expanded={show}
            aria-label={
              attributeDescriptiveName
                ? `${
                    show ? 'Close' : 'Open'
                  } explanation for ${attributeDescriptiveName}`
                : `${show ? 'Close' : 'Open'} explanation`
            }
          >
            <span className="ltFormExplainIcon">
              <i />
            </span>
          </a>
        ) : null}
        {show ? (
          <aside className="ltSidebar">
            <div
              className="content"
              id={this.explainId}
              role="complementary"
              ref={this.explainContentRef}
            >
              {/*eslint-disable-next-line react/no-danger*/}
              <div dangerouslySetInnerHTML={{ __html: content }} />
              <a
                role="button"
                className="next"
                onClick={this.handleShow}
                onKeyDown={this.handleKeyDown}
                tabIndex={0}
                aria-label={`Close explanation - ${buttonText}`}
              >
                {buttonText}
              </a>
            </div>
          </aside>
        ) : null}
      </div>
    );
  }
}
Explain.propTypes = {
  content: PropTypes.string,
  show: PropTypes.bool,
  dispatch: PropTypes.func,
  classExt: PropTypes.string,
  buttonText: PropTypes.string,
  attributeDescriptiveName: PropTypes.string,
};
export default connect()(Explain);
